const firebaseConfig = {
    apiKey: "AIzaSyC59k7RbEO2MTEX6KSoBGN4NxfmnHRcmnQ",
    authDomain: "assignment-11-92bb8.firebaseapp.com",
    projectId: "assignment-11-92bb8",
    storageBucket: "assignment-11-92bb8.appspot.com",
    messagingSenderId: "280872540485",
    appId: "1:280872540485:web:e8a73d4576e47bdb7c462c"
  };
  export default firebaseConfig;